import React, { useEffect, useState } from "react";

import CookieButton from "./CookieButton";
import CookieSettings from "./CookieSettings";

import "assets/css/Cookie.min.css";
import clg from "functions/log";
import settings from "configs/settings";

import getCookie from "components/Cookie/getCookie";

const CookieBar = ({
  cookieSettingsOpen = false,
  setCookieSettingsOpen,
  explainText = "Weboldalunk zavartalan műkődéséhez, valamint a weboldal látogatottságának méréséhez sütiket használunk.",
  moreInformation = (
    <span>
      További információkért tekintse meg a{" "}
      <a
        href={settings.files.termsOfUse}
        rel="noopener noreferrer"
        target="_blank"
      >
        felhasználási feltételeinket
      </a>{" "}
      és az{" "}
      <a
        href={settings.files.privacyPolicy}
        rel="noopener noreferrer"
        target="_blank"
      >
        adatvédelmi irányelveket
      </a>
    </span>
  ),
}) => {
  //localStorage.removeItem("cookie_settings"); //RESET

  const cookie_settings = JSON.parse(localStorage.getItem("cookie_settings"));

  const [accepted, setAccepted] = useState(
    cookie_settings === null ? false : cookie_settings.accepted
  );

  const analyticsCookieAccepted = getCookie("cookie_settings", "analytics");

 // const [settingsOpen, setSettingsOpen] = useState(cookieSettingsOpen);


    /* useEffect(()=>{
      setSettingsOpen(cookieSettingsOpen)
    },[cookieSettingsOpen]) */

  const settingItems = [
    {
      checked: true,
      nonModifiableValue: true, //Ez az érték fog beírásra kerülni a settings_cookie-ba FIXEN
      settingName: "accepted",
      hidden: true,
    }, //FIXEN BENNE KELL MARADNIA A settingItems-ben !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
    {
      title: "Működéshez szükséges (nem kikapcsolható)",
      description:
        "A weboldal zavartalan működéséhez használt sütik, amelyek a sütibeállítások tárolását, illetve bejelentkezett felhasználók esetén, a munkamenethez szükséges adatokat tárolják.",
      disabled: true,
      checked: true,
      nonModifiableValue: true, //Ez az érték fog beírásra kerülni a settings_cookie-ba FIXEN
      settingName: "operational",
    },
    {
      title: "Statisztika",
      description:
        "A weboldal látogatottságának méréséhez használt sütik (pl. Google Analytics).",
      checked: analyticsCookieAccepted,
      settingName: "analytics",
    },
  ];

  const acceptAll = () => {
    let toSave = {};
    settingItems.map((curr, index) => {
      toSave[curr.settingName] = true;
    });

    localStorage.setItem("cookie_settings", JSON.stringify(toSave));
    setAccepted(true);
  };

  const acceptSelected = (selected) => {
    localStorage.setItem("cookie_settings", JSON.stringify(selected));
    setAccepted(true);
    setCookieSettingsOpen(false);
  };

  return (
    <>
      {!accepted && (
        <div className="cookie-bar">
          <div className="row">
            <div className="col-12 inner">
              <div>{explainText}</div>
              <div>{moreInformation}</div>
              <div>
                <CookieButton
                  text="Összes elfogadása"
                  icon="fas fa-check"
                  className="primary"
                  onClick={() => acceptAll()}
                />
              </div>
              <div className="settings" onClick={() => setCookieSettingsOpen(true)}>
                Beállítások testreszabása
              </div>
            </div>
          </div>
        </div>
      )}

      {cookieSettingsOpen && (
        <CookieSettings
          setOpen={setCookieSettingsOpen}
          items={settingItems}
          acceptSelected={acceptSelected}
        />
      )}
    </>
  );
};

export default CookieBar;
